import { render, staticRenderFns } from "./TeamRequestList.vue?vue&type=template&id=caf54368&scoped=true"
import script from "./teamRequestList.ts?vue&type=script&lang=ts&external"
export * from "./teamRequestList.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequestList.vue?vue&type=style&index=0&id=caf54368&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf54368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caf54368')) {
      api.createRecord('caf54368', component.options)
    } else {
      api.reload('caf54368', component.options)
    }
    module.hot.accept("./TeamRequestList.vue?vue&type=template&id=caf54368&scoped=true", function () {
      api.rerender('caf54368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/client/team-requests/team-request-list/TeamRequestList.vue"
export default component.exports